export default {"src":"/_next/static/media/print.9f0bba89.svg","height":683,"width":683};